import React, { useCallback, useEffect, useRef } from 'react';
import { AutoTextarea } from './ScriptTranslationView.styles';

export const AutoResizeTextarea: React.FC<
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
> = props => {
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  const resize = useCallback(() => {
    const textarea = textareaRef.current;
    if (!textarea) return;
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  }, []);

  useEffect(() => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    resize();

    textarea.addEventListener('input', resize);
    window.addEventListener('resize', resize);

    return () => {
      textarea.removeEventListener('input', resize);
      window.removeEventListener('resize', resize);
    };
  }, [resize]);

  useEffect(() => {
    resize();
  }, [props.value, resize]);

  return <AutoTextarea {...props} ref={textareaRef} rows={1} />;
};
